import React from 'react';
import { DepartmentCockpit } from '../components/DepartmentCockpit';

export function SupplyPage() {
  return (
    <div className="pb-12">
      <DepartmentCockpit
        section="supply"
        pageTitle="Supplier & Inventory Health"
        pageEyebrow="Supply Chain"
        pageDescription="End-to-end visibility from procurement through fulfillment."
      />
    </div>
  );
}
